import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCastboxComponent } from './simple-icons-castbox.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCastboxComponent ],
    exports:      [ SimpleIconsCastboxComponent ],
    bootstrap:    []
})
export class SimpleIconsCastboxModule {}
